module.exports = __webpack_public_path__ + "1792395595471/images/cloud-slash.f6f5a02.svg";